/***
 * 创建人：但志强
 * 时间：2019-06-11
 * 描述：审核待办模块 用于公共的待办 和查看业务
 * 更新说明:
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SwWorkFlowService } from './sw-work-flow.service';
import { SwWorkFlowDirective } from './sw-work-flow.directive';
import { SwWorkFlowComponent } from './sw-work-flow.component';
import { FormsModule } from '@angular/forms';
import { BasicComponentsModule } from '../../basic-components/basic-components.module';
import { SwProcessToDosTableComponent } from './sw-process-to-dos-table/sw-process-to-dos-table.component';
import { SwOperatorModalComponent } from './sw-operator-modal/sw-operator-modal.component';
import { SwApprovalModalComponent } from './sw-approval-modal/sw-approval-modal.component';
import { SwAllUserModalComponent } from './sw-all-user-modal/sw-all-user-modal.component';
import { SwProcessToCompletionTableComponent } from './sw-process-to-completion-table/sw-process-to-completion-table.component';
import { SwProcessToPublishedTableComponent } from './sw-process-to-published-table/sw-process-to-published-table.component';

@NgModule({
  imports: [
    CommonModule,
    BasicComponentsModule,
    FormsModule
  ],
  providers: [SwWorkFlowService],
  declarations: [SwWorkFlowDirective,SwWorkFlowComponent, SwProcessToDosTableComponent,SwProcessToCompletionTableComponent,SwProcessToPublishedTableComponent,SwOperatorModalComponent,SwApprovalModalComponent,SwAllUserModalComponent],
  exports: [SwWorkFlowDirective,SwWorkFlowComponent,SwProcessToDosTableComponent,SwProcessToCompletionTableComponent,SwProcessToPublishedTableComponent,SwOperatorModalComponent,SwApprovalModalComponent,SwAllUserModalComponent],
  entryComponents:[SwWorkFlowComponent,SwOperatorModalComponent,SwApprovalModalComponent,SwAllUserModalComponent]
})
export class SwWorkFlowModule { } 
